module.exports = __webpack_public_path__ + "img/owl-pink-right.c8710764.png";